<template>
  <div class="container-fluid client">
    <div class="clientWrap">
      <div class="row">
        <div class="col-md-12">
          <div class="savedFilters py-3 d-flex flex-wrap align-items-center">
            <!-- LEFT SIDE (filters + title) -->
            <div class="d-flex flex-wrap align-items-center flex-grow-1 gap-2">
              <span class="mr-2" style="color: #ffffff;" id="v-step-0">
                <i class="fa fa-filter me-2"></i> My Filters:
              </span>
              <div
                v-for="filter in matchedFilterList.slice(0, 6)"
                :key="filter.id"
                class="filter mt-2"
                :class="{ active: selectedFilter === filter.id }"
                @click="selectFilter(filter)"
              >
                <span class="clr org"></span>
                {{
                  filter.filterName
                }}
              </div>
            </div>
            <div class="dropdown" v-if="matchedFilterList.length > 6">
              <button
                class="btn btn-icn ms-auto dropdown-toggle"
                type="button"
                id="dropdownMenu2"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <i class="fa fa-eye mr-2"></i> More Filters
                <i class="fa fa-caret-down ms-2"></i>
              </button>

              <div class="dropdown-menu" aria-labelledby="dropdownMenu2">
                <button
                  v-for="filter in matchedFilterList.slice(6)"
                  :key="filter.id"
                  @click="selectFilter(filter ,true)"
                :class="{ active: selectedFilter === filter.id }"
                  class="dropdown-item"
                  type="button"
                >
                  <span class="clr"></span>
                  {{ filter.filterName }}
                </button>
              </div>
            </div>
              <a @click="toggleImportModal" class="btn btn-primary btn-sm mr-2" style="color: white; font-weight: 400;" id="v-step-1">
              <i class="fas fa-file-import"></i> Import portfolio
            </a>
          </div>
        </div>
      </div>

      <!-- OFFERINGS TABLE -->

      <div class="row">
        <div :class="{'col-lg-8 col-md-7 col-sm-12 mt-1': !ishideTradeHistory, 'col-lg-12 col-md-12 col-sm-12 mt-1': ishideTradeHistory}" class="col-lg-8 col-md-7 col-sm-12 mt-1 pr-4">
          <div class="d-flex justify-content-between align-items-center mb-1">
             <div class="search-box d-flex align-items-center ml-1">
                  <i class="fa fa-search cursor-pointer" @click="search"></i>
                  <input
                    type="text"
                    @keyup.enter="search"
                    class="form-control"
                    placeholder="Enter CUSIP here"
                    v-model="searchText"
                  />
                  <div
                    v-if="searchText && searchText.trim() != ''"
                    style="margin-left: -20px"
                    class="clear-icon cursor-pointer"
                    @click="
                      searchText = ''
                      search()
                    "
                  >
                    <i class="fa fa-times"></i>
                  </div>
                </div>
                    <!-- <div class="d-flex justify-content-end mb-2">
             <a @click="toggleImportModal" class="btn btn-success btn-sm mr-2 mt-1" style="color: white;">
                      <i class="fas fa-file-import"></i> Import portfolio
                    </a>
          </div> -->
          <div class="d-flex justify-content-end mb-2">
            <router-link to="/client/filter">
            <a  class="btn btn-primary btn-sm mr-2 mt-2" style="color: white; font-weight: 400;" id="v-step-2">
              <i class="fas fa-filter"></i> Add Filter
            </a>
            </router-link>
            <span class="cursor-pointer mt-3 text-white" @click="selectColumnOption()" id="v-step-3">
              <i class="fa fa-cog"></i>
              Column Options
            </span>
          </div>
          </div>
          <div class="table-responsive fixed table-wrapper">
            <table class="table table-hover">
              <thead>
                <tr>
                  <th
                  id="v-step-4"
                    v-for="col in columnNames"
                    :key="col.columnvalue"
                    scope="col"
                    v-bind:class="[
                      sortOrder == 'ASC' && sortColumn == col.columnvalue
                        ? 'sort-client-asc'
                        : '',
                      sortOrder == 'DESC' && sortColumn == col.columnvalue
                        ? 'sort-client-desc'
                        : '',
                      col.columntype == 'currency'
                        ? 'text-right'
                        : col.columnvalue == 'issuer'
                        ? 'text-left'
                        : 'text-center'

                    ]"
                    @click="sort(col.columnvalue)"
                  
                   class="sort"
                  >
                    {{ col.column === 'SP_RATING' ? 'S&P RATING' : col.column.replace(/_/g, ' ') }}


                  </th>
                  <th scope="col" v-if="columnNames.length" class="text-center" id="v-step-5">ACTIONS</th>
                </tr>
              </thead>

              <tbody >
                <div class="loader" v-if="loading"></div>
                <tr v-if="offerings.length === 0 && !loading" >
                  <td colspan="15" class="text-center">No data available</td>
                </tr>
                <tr
                  v-for="offer in offerings"
                  :key="offer.id"
                  @click="onSelectBid(offer)"
      
                  v-bind:class="{'highlight-row' : offer.cusipFound , 'selected': selectedBid && selectedBid.id === offer.id }">
                
                  <td
                    v-for="(column, index) in columnNames"
                    :class="[
                      column.columntype == 'currency'
                        ? 'text-right'
                        : column.columnvalue == 'issuer'
                        ? 'text-left'
                        : 'text-center'
                    ]"
                    :key="index"
                  >
                    <span v-if="column.columntype == 'currency'">{{
                      offer[column.columnvalue] | currency
                    }}</span>
                    <span v-else-if="column.columntype == 'percentage'">
                      <div
                        v-if="
                          column.columnvalue == 'askYtc' ||
                          column.columnvalue == 'askYtm' ||
                          column.columnvalue == 'askYtw'
                        "
                      >
                        <span
                          v-if="typeof offer[column.columnvalue] === 'number'"
                        >
                          <span v-if="offer[column.columnvalue] > 16">
                            <span>N/A</span>
                          </span>
                          <span v-else>
                            {{ offer[column.columnvalue]  }}%
                          </span>
                        </span>
                        <span v-else>{{ offer[column.columnvalue] }}%</span>
                      </div>
                      <div v-else>
                        <span
                          v-if="typeof offer[column.columnvalue] === 'number'"
                          >{{ offer[column.columnvalue] | percent(3) }}</span
                        >
                        <span v-else>{{ offer[column.columnvalue] }}</span>
                      </div>
                    </span>
                    <span v-else-if="column.columnvalue == 'cusip'">
                      <span  v-bind:class="{'cusip-badge': offer.highlightMaterialEvent}" >{{ offer[column.columnvalue] }}</span>
                    </span>
                    <span v-else-if="column.columnvalue == 'settlementDate'">
                      <span
                        v-if="
                          offer.settlementDate && !offer.isRegularSettlement
                        "
                        class="text-red"
                        >{{ offer[column.columnvalue] }}</span
                      >
                      <span v-else>{{ offer[column.columnvalue] }}</span>
                    </span>
                    <span
                      v-else-if="column.columnvalue == 'firstSettlementDate'"
                    >
                      <span
                        v-if="
                          !offer.settlementDate && !offer.isRegularSettlement
                        "
                        class="text-red"
                        >{{ offer[column.columnvalue] }}</span
                      >
                      <span v-else>{{ offer[column.columnvalue] }}</span>
                    </span>
                    <span
                      v-else-if="Array.isArray(offer[column.columnvalue])"
                      >{{ offer[column.columnvalue].toString() }}</span
                    >
                    <span v-else-if="column.columnvalue == 'minQty'">{{
                      offer[column.columnvalue]
                        ? offer[column.columnvalue]
                        : 'N/A'
                    }}</span>

                    <span v-else>{{ offer[column.columnvalue] }}</span>
                  </td>

                  <td class="text-center">
                    <button
                      class="btn btn-primary"
                      @click.stop="toggleBidModal(offer, 'BID')"
                    >
                      BID
                    </button>
                    <button
                      type="button"
                      class="btn btn-success"
                      @click.stop="toggleBidModal(offer, 'BUY')"
                    >
                      BUY
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          
          </div>
            <nav
              aria-label="Page navigation example"
              v-if="!(offerings.length == 0)"
            >
              <ul class="pagination justify-content-center">
                <li class="page-item" v-bind:class="{ disabled: !prevCursor }">
                  <a
                    class="page-link cursor-pointer"
                    @click="nextOrPrev('prev')"
                  >
                    <i class="fa fa-angle-left"></i>
                    <span class="sr-only">Previous</span>
                  </a>
                </li>
                <li class="page-item active">
                  <a class="page-link">{{ currentPage }}</a>
                </li>
                <li class="page-item" v-bind:class="{ disabled: !nextCursor }">
                  <a
                    class="page-link cursor-pointer"
                    @click="nextOrPrev('next')"
                  >
                    <i class="fa fa-angle-right"></i>
                    <span class="sr-only">Next</span>
                  </a>
                </li>
              </ul>
            </nav>
        </div>

        <div class="col-lg-4 col-md-5 col-sm-12 mt-3" :hidden="ishideTradeHistory">
      
          <TradeHistory
            :selectedBid="selectedBid"
            v-bind:cusipId="selectedBid ? selectedBid.cusip : ''"
            @closeTradeHistory="ishideTradeHistory = true"
          />
        </div>
      </div>

      <!-- MARKET DEPTH + SECURITY DETAILS -->
      <div class="row">
        <div class="col-md-4 mt-3" id="v-step-6">
          <MarketDepth
            :selectedBid="selectedBid"
            v-bind:cusipId="selectedBid ? selectedBid.cusip : ''"
          />
        </div>

        <div class="col-md-8 mt-3" id="v-step-7">
          <SecurityDetails
            :selectedBid="selectedBid"
            v-bind:cusipId="selectedBid ? selectedBid.cusipId : ''"
          />
        </div>
      </div>
    </div>

    <!-- MODAL -->
    <BidOrBuyModal
      v-if="isBidModalOpen"
      @close="isBidModalOpen = false"
      :selectedBid="selectedBid"
      :bidType="bidType"
    />
    <FeedColumnOption
      v-if="showColumnOption"
      :moduleName="'CLIENT'"
      @close="selectColumnOption()"
    />
    <ClientImportCusip v-if="showImportModal" @close="toggleImportModal" />
     <v-tour name="myTour" :steps="steps" :callbacks="myCallbacks" :options="myOptions"></v-tour>

  </div>

</template>

<script>
import config from '@/config'
import authService from '@/authService'
import TradeHistory from '@/components/client/TradingHistory.vue'
import MarketDepth from '@/components/client/MarketDepth.vue'
import SecurityDetails from '@/components/client/SecurityDetails.vue'
import BidOrBuyModal from '@/components/client/BidOrBuyModal.vue'
import FeedColumnOption from '@/components/client/ClientColumnOptions.vue'
import ClientImportCusip from '@/components/client/ClientImportCusip.vue'

export default {
  name: 'ClientDashboard',
  components: {
    TradeHistory,
    MarketDepth,
    SecurityDetails,
    BidOrBuyModal,
    FeedColumnOption,
    ClientImportCusip,
  },
  data () {
    return {
      selectedBid: null,
      ishideTradeHistory: true,
      isBid: false,
      calculatedProceeds: false,
      matchedFilterList: [],
      cursor: '',
      sortColumn: null,
      sortOrder: null,
      loading: false,
      nextCursor: null,
      prevCursor: null,
      currentPage: 1,
      perPage: 10,
      offerings: [],
      isBidModalOpen: false,
      showImportModal: false,
      offeringFeedStatus : {},
      columnNames: [
        // { column: 'CUSIP', columnvalue: 'cusip' },
        // { column: 'ISSUER', columnvalue: 'issuer' },
        // { column: 'STATE', columnvalue: 'state' },
        // { column: 'COUPON', columnvalue: 'coupon' ,columnType: "percentage" },
        // { column: 'MATURITY DATE', columnvalue: 'maturityDate' },
        // { column: 'CALL DATE', columnvalue: 'callDate' },
        // { column: 'SP RATING', columnvalue: 'ratingSP' },
        // { column: 'PRICE', columnvalue: 'askPx' , columnType: "price" },
        // { column: 'QUANTITY', columnvalue: 'askQty' },
        // { column: 'MIN QTY', columnvalue: 'minQty' },
        // { column: 'YTM', columnvalue: 'askYtm' ,columnType: "percentage" },
        // { column: 'YTC', columnvalue: 'askYtc' ,columnType: "percentage" },
        // { column: 'YTW', columnvalue: 'askYtw' ,columnType: "percentage" },
        // // { column: 'DURATION', columnvalue: 'duration' },
        // // { column: 'CONVEXITY', columnvalue: 'convexity' },
        // // { column: 'OFFER SOURCE', columnvalue: 'offerSource' },
        // // { column: 'ECN', columnvalue: 'ecn' },
        // // { "column": "MATCHED_FILTER", "columnvalue": "matchedFilters" },
        // { column: 'SINK INDICATOR', columnvalue: 'sinkIndicator' },
        // { column: 'FIRST SETTLEMENT DATE', columnvalue: 'firstSettlementDate' },
        // { column: 'SETTLEMENT DATE', columnvalue: 'settlementDate' },
        // // { column: 'ISSUE DATE', columnvalue: 'issueDate' },
        // { column: 'BOND INSURER', columnvalue: 'bondInsurer' },
        // { column: 'PROCEEDS', columnvalue: 'proceeds' },
        // { column: 'MIN DENOM', columnvalue: 'minDenom' },
        // { column: 'MUNI SEC TYPE', columnvalue: 'muniSecType' },
        // { column: 'FED TAX STATUS', columnvalue: 'fedTaxStatus' },
        // { column: 'STATE TAX STATUS', columnvalue: 'stateTaxStatus' },
        // { column: 'PUT INDICATOR', columnvalue: 'putIndicator' },
        // { column: 'UNDERLYING RATING', columnvalue: 'ratingUnderlying' }
      ],
      bidType: '',
      selectedFilter: null,
      searchText: '',
      showColumnOption: false,
      clientCusips : [],
      steps: [
          {
            target: '#v-step-0',  // We're using document.querySelector() under the hood
            content: ` All active filters you have created are displayed at the top. Selecting a filter displays the offerings that match the selected filter criteria.`,
            params: {
              enableScrolling: false
            }
          },
            {
            target: '#v-step-1',  // We're using document.querySelector() under the hood
            content: `Upload CUSIP list to monitor or track bonds you own. A downloadable sample file is provided for reference.`,
            params: {
              enableScrolling: false
            }
          },
          {
            target: '#v-step-2',  // We're using document.querySelector() under the hood
            content: `Create custom filters based on your preferred criteria to monitor relevant offerings.`,
            params: {
              enableScrolling: false
            }
          },
          {
            target: '#v-step-3',  // We're using document.querySelector() under the hood
            content: `To view additional columns or change the sort, use the Column Settings option to customize your view.`,
            params: {
              enableScrolling: false
            }
          },
          {
            target: '#v-step-4',  // We're using document.querySelector() under the hood
            content: `Once a filter is created, the system begins displaying offerings that match the defined criteria. Selecting an offering from the list displays detailed information in multiple sections on this page.`,
            params: {
              enableScrolling: false
            }
          },

          {
            target: '#v-step-5',  // We're using document.querySelector() under the hood
            content: `You can submit Bid or Buy requests directly from the offer list by clicking the respective Bid or Buy button for each offer.`,
            params: {
              enableScrolling: false
            }
          },
          {
            target: '#v-step-6',  // We're using document.querySelector() under the hood
            content: `Displays all available offerings for the selected CUSIP.`,
            params: {
              enableScrolling: false
            }
          },
          {
            target: '#v-step-7',  // We're using document.querySelector() under the hood
            content: `Provides comprehensive CUSIP data organized across multiple tabs.`,
            params: {
              enableScrolling: false
            }
          }
        ],
         myCallbacks: {
          onFinish: () => {
           localStorage.setItem('client_tour_completed_dashboard', 'true');
           this.$router.push("/client/mybids")
          },
          onSkip: () => {
            localStorage.setItem('client_tour_completed_dashboard', 'true');
          }
        },
        myOptions: {
          enableScrolling: false,
          labels: {
            buttonSkip: 'Skip tour',
            buttonPrevious: 'Previous',
            buttonNext: 'Next',
            buttonStop: 'Next'
          }
        },
    }
  },
  methods: {
   
      toggleImportModal() {
      this.showImportModal = !this.showImportModal;
      if(!this.showImportModal){
          this.fetchClientPortfolio();
      }
    },
      fetchClientPortfolio () {
      const auth = {
        headers: { 'org-token': authService.getOrgToken() }
      }

      this.$http
        .get(
          config.baseUrlAutoBidder +
            `/offering-feed/client-cusip?userId=` +
            authService.getUser().id,
          auth
        )
        .then(response => {
          // Handle successful response
          console.log('Client Portfolio Data:', response.data)
          this.clientCusips = response.data.map(item => item.cusip);
        })
        .catch(error => {
          // Handle error
          console.error('Error fetching client portfolio data:', error)
        })
    },
     search () {
      this.searchText = this.searchText.trim()
      this.getOfferList()
    },
    sort (column) {
      this.sortColumn = column
      this.sortOrder =
        this.sortOrder == 'ASC'
          ? (this.sortOrder = 'DESC')
          : (this.sortOrder = 'ASC')
      this.getOfferList()
    },
    selectColumnOption () {
      this.showColumnOption = !this.showColumnOption
      if (!this.showColumnOption) this.getColumnSettings()
    },
    getColumnSettings () {
      const auth = {
        headers: { 'org-token': authService.getOrgToken() }
      }
      this.$http
        .get(
          config.baseUrlAutoBidder +
            '/offering-feed/column-setting?userId=' +
            authService.getUser().id,
          auth
        )
        .then(res => {
          if (res.data && res.data.columnInfos) {

            if(!authService.getUser().isColumnSettingExist){
                res.data.columnInfos.forEach(column => {
                  column.default = false;
                  column.selected = false;
                  
                })
                res.data.columnInfos.forEach(column => {
                      if (
                        column.column === 'QUANTITY' ||
                        column.column === 'CUSIP' ||
                        column.column === 'DESCRIPTION' ||
                        column.column === 'COUPON' ||
                        column.column === 'MATURITY_DATE' ||
                        column.column === 'CALL_DATE' ||
                        column.column === 'PRICE' ||
                        column.column === 'YTM' ||
                        column.column === 'SP_RATING' ||
                        column.column === 'YTW' ||
                        column.column === 'BOND_INSURER'
                      ) {
                        column.default = true;
                        column.selected = true;
                      }
                });
              }

            res.data.columnInfos = res.data.columnInfos.filter(
              column =>
                column.columnvalue !== 'matchedFilters' &&
                column.columnvalue !== 'duration' &&
                column.columnvalue !== 'convexity' &&
                column.columnvalue !== 'offerSource' &&
                column.columnvalue !== 'ecn'
            );
            console.log("Filtered Columns: ", res.data.columnInfos);
            this.columnNames = res.data.columnInfos.filter(
              column => column.selected
            )


            this.getOfferList()
          }
        })
        .catch(e => {
          console.log(e)
        })
    },

    nextOrPrev (nextOrPrev) {
      if (!this.loading) {
        this.getOfferList(nextOrPrev)
      }
    },
    toggleBidModal (bid, type) {
      this.selectedBid = bid
      this.isBidModalOpen = !this.isBidModalOpen
      this.bidType = type
    },
    getOfferList (mode) {
      this.loading = true
      const auth = {
        headers: { 'org-token': authService.getOrgToken() }
      }
      if (mode == 'next') {
        this.cursor = this.nextCursor
        if (!this.nextCursor) return
      }
      if (mode == 'prev') {
        this.cursor = this.prevCursor
        if (!this.prevCursor) return
      }
      if (!mode) {
        this.cursor = null
        this.currentPage = 1
      }
      let url = ''
      let body = {
        size: this.perPage,
        cursor: this.cursor ? this.cursor : null,
        userId: authService.getUser().id,
        search: this.searchText ? this.searchText : null,
        ecn: null,
        sortColumn: this.sortColumn,
        sortOrder: this.sortOrder,
        isForClient: true,
        filterIds: this.selectedFilter ? [this.selectedFilter] : []
      }
      url = config.baseUrlAutoBidder + '/offering-feed/list-hits'

      this.$http
        .post(url, body, auth)
        .then(result => {
          this.nextCursor = result.data.pageInfo.nextCursor
          this.prevCursor = result.data.pageInfo.prevCursor
          this.offerings = result.data.content
          this.offerings.forEach(offer => {
            offer.cusipFound = false
            if(this.clientCusips.includes(offer.cusip)){
              offer.cusipFound = true
            }
          })
          this.loading = false
          if (mode == 'next') {
            this.currentPage = this.currentPage + 1
          }
          if (mode == 'prev') {
            this.currentPage = this.currentPage - 1
          }
        })
        .catch(e => {
          console.log(e)
          this.loading = false
        })
    },
    onSelectBid (bid) {
      this.ishideTradeHistory = false;
      this.selectedBid = bid
      this.calculatedProceeds = false
    },
    selectFilter (filter,fromDropdown) {
        if(fromDropdown){
          this.matchedFilterList = [
            filter,
            ...this.matchedFilterList.filter(f => f.id !== filter.id)
          ]
        }
      
      if (this.selectedFilter === filter.id) {
        this.selectedFilter = null // toggle off
      } else {
        this.selectedFilter = filter.id // toggle on
      }
      this.getOfferList()
    },
    getMatchedFilter () {
      const auth = {
        headers: { 'org-token': authService.getOrgToken() }
      }
      this.$http
        .get(
          config.baseUrlAutoBidder +
            '/offering-feed/filter-dropdown?userId=' +
            authService.getUser().id +
            '&isForClient=true',
          auth
        )
        .then(res => {
          //show filter name with 'portfolio' as first record .

          const portfolioFilter = res.data.content.find(filter => filter.filterName.toLowerCase().includes('portfolio'));
          if (portfolioFilter) {
            const index = res.data.content.indexOf(portfolioFilter);
            res.data.content.splice(index, 1);
            res.data.content.unshift(portfolioFilter);
          }

          this.matchedFilterList = res.data.content


        
        })
        .catch(e => {
          console.log(e)
        })
    }
  },
  mounted () {
    
    this.fetchClientPortfolio()
    this.getMatchedFilter()
    // this.getOfferList()
    this.getColumnSettings()
    this.$root.$on('onsearch', searchText => {
      this.selectedBid = null
      this.searchText = searchText
      this.getOfferList()
    })

    this.$root.$on("offeringfeedstatus", (data) => {
      this.offeringFeedStatus = data.status;
      if(this.offeringFeedStatus.viewStatus == 'READY_FORCED'){
          this.getOfferList();
      }
    });

    if(!localStorage.getItem('client_tour_completed_dashboard') ){
      this.$tours['myTour'].start()
    }

  },
  beforeDestroy () {
    this.$root.$off('onsearch')
  }
}
</script>
<style scoped>
.loader {
  width: 48px;
  height: 48px;
  border: 4px solid rgba(255, 255, 255, 0.1);
  border-top-color: #4c6fff; /* soft neon blue */
  border-radius: 50%;
  animation: spin 0.9s linear infinite;
  margin: auto;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
.selected {
  background-color: #161529;
}
.sort-desc::before {
  color: #fff !important;
}
.sort-desc::after {
  color: #fff !important;
}
.search-box input, .clientHead .search-box input:focus {
    padding-left: 3.5rem;
    border-radius: 100px;
    background-color: #22203B !important;
    border: 1px solid #303030;
    box-shadow: none;
    color: #FFFFFF;
}
.cusip-text {
  color: #ffffff;
  font-weight: 600;
  font-size: 13px;
  padding-left: 10px;
  position: relative;
}

.cusip-badge {
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.15);
  color: #fff;
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 600;
}

.highlight-row {
  background-color: rgb(239 68 68 / 28%);
}


</style>
